import { StatusCodes } from '@e3dc-react/shell/Libs'
import { AuthFetchWithResponse, ApiResult, AuthFetchError } from '@e3dc-react/shell/Types'
import { throwApiError } from 'src/Libs/api'
import { MyPvNetworkScanModel } from '../types'

/** Fetches the MyPV network scan result for a specific EMC device */
export const scanEmcMyPv = async (
  installationId: number,
  emcId: string,
  authFetch: AuthFetchWithResponse
): Promise<ApiResult<MyPvNetworkScanModel | null>> => {
  try {
    const response = await authFetch<MyPvNetworkScanModel>({
      endpoint: process.env.REACT_APP_INSTALLATIONS_ENDPOINT,
      path: `installations/${installationId}/device-links/${emcId}/scan/my-pv`,
    })

    if (response.status !== StatusCodes.OK) {
      return new ApiResult<null, Error | AuthFetchError>(null)
    }

    return new ApiResult<MyPvNetworkScanModel>(response.data)
  } catch (error) {
    return throwApiError(error, 'Failed to scan EMC MyPV network:')
  }
}
